import type { FiltrosMontagem } from '../types';

interface Props {
  filtros: FiltrosMontagem;
  aoMudar: (f: FiltrosMontagem) => void;
}

const TOGGLES: { chave: keyof FiltrosMontagem; rotulo: string }[] = [
  { chave: 'soSemEquipe', rotulo: 'Só sem equipe' },
  { chave: 'primeiroServir', rotulo: 'Primeiro servir' },
  { chave: 'jaServiu', rotulo: 'Já serviu antes' },
  { chave: 'fica5Dias', rotulo: 'Fica os 5 dias' },
  { chave: 'vaiPastoreio', rotulo: 'Vai ao Pastoreio' },
  { chave: 'temFilhos', rotulo: 'Tem filhos pequenos' },
  { chave: 'temRestricao', rotulo: 'Tem restrição alimentar' },
];

export default function BarraFiltrosMontagem({ filtros, aoMudar }: Props) {
  function set<K extends keyof FiltrosMontagem>(chave: K, valor: FiltrosMontagem[K]) {
    aoMudar({ ...filtros, [chave]: valor });
  }

  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-3">
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <label className="relative block">
          <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-secondary-400">
            <i className="ri-search-line text-sm" />
          </span>
          <input
            type="text"
            value={filtros.busca}
            onChange={(e) => set('busca', e.target.value)}
            placeholder="Buscar por nome"
            className="w-full rounded-md border border-secondary-300 bg-white py-2 pl-9 pr-3 text-sm text-foreground-950 outline-none placeholder:text-secondary-400 focus:border-primary-400"
          />
        </label>

        <label className="relative block">
          <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-accent-500">
            <i className="ri-magic-line text-sm" />
          </span>
          <input
            type="text"
            value={filtros.talentos}
            onChange={(e) => set('talentos', e.target.value)}
            placeholder="Buscar nos talentos (ex.: violão)"
            className="w-full rounded-md border border-secondary-300 bg-white py-2 pl-9 pr-3 text-sm text-foreground-950 outline-none placeholder:text-secondary-400 focus:border-accent-400"
          />
        </label>

        <input
          type="text"
          value={filtros.cidade}
          onChange={(e) => set('cidade', e.target.value)}
          placeholder="Cidade"
          className="w-full rounded-md border border-secondary-300 bg-white px-3 py-2 text-sm text-foreground-950 outline-none placeholder:text-secondary-400 focus:border-primary-400"
        />

        <input
          type="text"
          value={filtros.paroquia}
          onChange={(e) => set('paroquia', e.target.value)}
          placeholder="Paróquia"
          className="w-full rounded-md border border-secondary-300 bg-white px-3 py-2 text-sm text-foreground-950 outline-none placeholder:text-secondary-400 focus:border-primary-400"
        />
      </div>

      <div className="mt-2 flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1 rounded-full bg-secondary-100 p-1">
          {(
            [
              ['Todos', null],
              ['Homens', 'M'],
              ['Mulheres', 'F'],
            ] as [string, 'M' | 'F' | null][]
          ).map(([rotulo, valor]) => (
            <button
              key={rotulo}
              type="button"
              onClick={() => set('sexo', valor)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                filtros.sexo === valor
                  ? 'bg-white text-foreground-950'
                  : 'text-secondary-600 hover:text-foreground-900'
              }`}
            >
              {rotulo}
            </button>
          ))}
        </div>

        {TOGGLES.map((t) => {
          const ativo = !!filtros[t.chave];
          return (
            <button
              key={t.chave}
              type="button"
              onClick={() => set(t.chave, !ativo)}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
                ativo
                  ? 'border-primary-400 bg-primary-100 text-primary-700'
                  : 'border-secondary-200 bg-white text-secondary-600 hover:border-secondary-300'
              }`}
            >
              {t.rotulo}
            </button>
          );
        })}
      </div>
    </div>
  );
}